import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  public _searchProduct = new Subject<any>();
  public _searchOrder = new Subject<any>();
  public _searchCoupon = new Subject<any>();
  public _searchCustomer = new Subject<any>();
  public _searchPromotion = new Subject<any>();

  public _searchFilter = new Subject<any>();

  constructor() { }

  find(data: any, type: string) {
    if (type == 'product') {
      this._searchProduct.next(data);
    } else if (type == 'order') {
      this._searchOrder.next(data);
    } else if (type == 'coupon') {
      this._searchCoupon.next(data);
    } else if (type == 'customer') {
      this._searchCustomer.next(data);
    } else if (type == 'promotion') {
      this._searchPromotion.next(data);
    }
  }

  openFilter(data: any) {
    this._searchFilter.next(data);
  }
}
